import axios from "axios";
import { API_URL } from "@/utils/api.js";

export default {
  async loadTemuanCreate(context, payload) {
    const response = await axios({
      method: "GET",
      baseURL: API_URL,
      headers: { "Content-Type": "application/json" },
      url: "/api/temuan/create",
      params: {
        kode_lha: payload.idLha,
        token: localStorage.getItem("api_token")
      }
    });

    const responseData = response.data;

    if (response.status != 200) {
      const error = new Error(responseData.message || "Failed to fetch data");
      throw error;
    }

    return responseData;
  },

  async loadTemuan(context, payload) {
    const response = await axios({
      method: "GET",
      baseURL: API_URL,
      headers: { "Content-Type": "application/json" },
      url: "/api/temuan",
      params: {
        kode_lha: payload.idLha,
        token: localStorage.getItem("api_token")
      }
    });

    const responseData = await response.data;

    if (response.status != 200) {
      const error = new Error(responseData.message || "Failed to fetch data");
      throw error;
    }

    const temuan = [];

    for (const key in responseData) {
      const data = {
        id: responseData[key]["kode_temuan"],
        nomorLha: responseData[key]["Nomor_LHA"],
        idLha: responseData[key]["kode_lha"],
        nomorTemuan: responseData[key]["Nomor_Temuan"],
        kodeJenisTemuan: responseData[key]["Kode_Jenis_Temuan"],
        jenisTemuan: responseData[key]["Jenis_Temuan"],
        kodeKelompokTemuan: responseData[key]["Kode_Kelompok_Temuan"],
        kelompokTemuan: responseData[key]["Kelompok_Temuan"],
        kodeSubKelompokTemuan: responseData[key]["Kode_Sub_Kelompok_Temuan"],
        subKelompokTemuan: responseData[key]["Sub_Kelompok_Temuan"],
        memoTemuan: responseData[key]["Memo_Temuan"],
        flagTpk: responseData[key]["Flag_TPK"],
        posisiKasus: responseData[key]["Posisi_Kasus"],
        modusOperandi: responseData[key]["Modus_Operandi"],
        nilaiTemuan: responseData[key]["Nilai_Temuan"],
        // jumlahRekomendasi: responseData[key]["Jumlah_Rekomendasi"],
        // jumlahSaldoRekomendasi: responseData[key]["Jumlah_Saldo_Rekomendasi"],
        jumlahRekomendasi: responseData[key]["Total_Rekomendasi"],
        jumlahSaldoRekomendasi: responseData[key]["Nilai_Rekomendasi"],
        nilaiTl: responseData[key]["Nilai_TL"],
        statusTemuan: responseData[key]["Status_Temuan"],
        memoKoreksiTemuan: responseData[key]["Memo_Koreksi_Tem"]
      };

      temuan.push(data);
    }

    context.commit("setTemuan", temuan);
    context.commit("setFetchTimestamp");
  },

  async loadTemuanById(context, payload) {
    const response = await axios({
      method: "GET",
      baseURL: API_URL,
      url: `/api/temuan/${payload.idTemuan}`,
      params: {
        token: localStorage.getItem("api_token")
      }
    });

    const responseData = await response.data;

    if (response.status != 200) {
      const error = new Error(responseData.message || "Failed to fetch data");
      throw error;
    }

    const data = {
      id: responseData["kode_temuan"],
      nomorLha: responseData["Nomor_LHA"],
      idLha: responseData["kode_lha"],
      nomorTemuan: responseData["Nomor_Temuan"],
      kodeJenisTemuan: responseData["Kode_Jenis_Temuan"],
      jenisTemuan: responseData["Jenis_Temuan"],
      kodeKelompokTemuan: responseData["Kode_Kelompok_Temuan"],
      kelompokTemuan: responseData["Kelompok_Temuan"],
      kodeSubKelompokTemuan: responseData["Kode_Sub_Kelompok_Temuan"],
      subKelompokTemuan: responseData["Sub_Kelompok_Temuan"],
      memoTemuan: responseData["Memo_Temuan"],
      flagTpk: responseData["Flag_TPK"],
      posisiKasus: responseData["Posisi_Kasus"],
      modusOperandi: responseData["Modus_Operandi"],
      nilaiTemuan: responseData["Nilai_Temuan"],
      jumlahRekomendasi: responseData["Jumlah_Rekomendasi"],
      jumlahSaldoRekomendasi: responseData["Jumlah_Saldo_Rekomendasi"],
      nilaiTl: responseData["Nilai_TL"],
      statusTemuan: responseData["Status_Temuan"],
      memoKoreksiTemuan: responseData["Memo_Koreksi_Tem"]
    };

    context.commit("setTemuanById", data);
  },

  async createTemuan(context, payload) {
    const response = await axios({
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: payload,
      baseURL: API_URL,
      url: "/api/temuan",
      params: {
        token: localStorage.getItem("api_token")
      }
    });

    const responseData = await response.data;

    if (response.status != 200) {
      const error = new Error(responseData.message || "Failed to save data");
      throw error;
    }

    return responseData;
  },

  async deleteTemuanById(context, payload) {
    const response = await axios({
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      baseURL: API_URL,
      url: `/api/temuan/${payload.idTemuan}`,
      params: {
        token: localStorage.getItem("api_token")
      }
    });

    const responseData = await response.data;

    if (response.status != 200) {
      const error = new Error(responseData.message || "Failed to delete data");
      throw error;
    }

    return response;
  },

  async updateTemuanById(context, payload) {
    const response = await axios({
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: payload.data,
      baseURL: API_URL,
      url: `/api/temuan/${payload.idTemuan}`,
      params: {
        token: localStorage.getItem("api_token")
      }
    });

    const responseData = await response.data;

    if (response.status != 200) {
      const error = new Error(responseData.message || "Failed to update data");
      throw error;
    }

    return response;
  }
};
